import React from 'react'
import GenericTable from '../general/generic-table'
import { utilService } from '../../services/util-service'

interface SystemTableProps {
    data: any[]
    onEditClick?: (system: any) => void
}

const createMapping = (title: string, location: string[], type: string) => ({
    title, location, type
})

const mapping = [
    createMapping('ID', ['id'], 'int'),
    createMapping('System Name', ['name'], 'string'),
    createMapping('Abbreviation', ['abbreviation'], 'string'),
    createMapping('Type', ['type'], 'string'),
    createMapping('Logo URL', ['logoUrl'], 'string'),
    createMapping('Created At', ['createdAt'], 'date'),
]

export const SystemTable: React.FC<SystemTableProps> = ({ data, onEditClick }) => {
    const tableData: any[][] = data.map((record: any) =>
        mapping.map((m) => ({
            title: m.title,
            value: utilService.getCellValue(record, m),
            type: m.type,
        }))
    )

    const handleEditClick = onEditClick ? (rowData: any[]) => {
        const idCell = rowData.find((cell: any) => cell.title === 'ID')
        const sysId = Number(idCell?.value)
        const rawItem = data.find((item: any) => Number(item.id) === sysId)
        if (rawItem) onEditClick(rawItem)
    } : undefined

    return (
        <GenericTable
            data={tableData}
            recordName="Systems"
            onEditClick={handleEditClick}
            editColumn="ID"
            filterableColumns={['System Name', 'Abbreviation', 'Type']}
        />
    )
}

export default SystemTable
